<template>
  <div v-if="isPC" class="login-container" :style="{ backgroundImage: 'url(' + bigBg + ')' }">
    <div class="centers">
      <div class="login-form">
        <div class="centers-title">{{type==1?'免费':'申请'}}试用</div>
        <template v-if="!showImg">
          <el-form class="form-box" :hide-required-asterisk="true" ref="loginForm" label-width="100px" :model="loginForm" :rules="loginRules">
            <el-form-item label="姓名" prop="contract">
              <el-input v-model.trim="loginForm.contract" @keyup.enter.native="handleLogin" type="text" maxlength="20" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model.trim="loginForm.phone" v-removeSpace:numberLine="loginForm.phone" maxlength="11" @keyup.enter.native="handleLogin" type="text" placeholder="请输入11位手机号码"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model.trim="loginForm.code" v-removeSpace:numberLine="loginForm.code" @keyup.enter.native="handleLogin" type="text" maxlength="6" placeholder="请输入验证码"></el-input>
              <el-button :loading="loadingCode" :disabled="getCodeTime>0?true:false" @click.stop="getCode()" class="get-code" type="text">{{getCodeTime?`${getCodeTime}s后重新获取`:'获取验证码'}}</el-button>
            </el-form-item>
            <el-form-item label="店铺类型" prop="shopType">
              <el-input v-model.trim="loginForm.shopType" @keyup.enter.native="handleLogin" type="text" maxlength="100" placeholder="商超/零售/餐饮"></el-input>
            </el-form-item>
            <el-form-item label="店铺数量" prop="shopFace">
              <el-input v-model.trim="loginForm.shopFace" @keyup.enter.native="handleLogin" type="text" maxlength="100" placeholder="例如20家"></el-input>
            </el-form-item>
            <div class="login-btn">
              <div v-if="type==2" class="centers-title-des">提交申请后，我们将于1个工作日内与您联系</div>
              <el-button :loading="loading" type="primary" style="width:100%; height:40px;" @click.native.prevent="handleLogin">{{type==1?'免费':'申请'}}试用</el-button>
              <el-checkbox style="margin-top:16px" v-model="checked">我已阅读并同意<el-link target="_blank" href="https://privacy.kemai.com.cn/petroleum/privacy.html" :underline="false" type="primary">《个人信息授权与隐私政策》</el-link>
              </el-checkbox>
            </div>
          </el-form>
        </template>
        <template v-else>
          <el-image style="margin: 16px 0px; width:100%;height:auto" :src="showImgUrl" fit="fill"></el-image>
        </template>
      </div>
    </div>
  </div>
  <div v-else class="mui-box" :style="{ backgroundImage: 'url(' + bigBg + ')' }">
    <div class="mui-con">
      <div class="mui-con-title">{{type==1?'免费':'申请'}}试用</div>
      <template v-if="!showImg">
        <div class="mui-form">
          <div class="mui-form-item">
            <div class="mui-form-item-label">
              姓名
            </div>
            <div class="mui-form-item-value">
              <input @blur="blur('contract')" v-model.trim="loginForm.contract" type="text" maxlength="20" placeholder="请输入姓名">
            </div>
            <div v-if="loginRulesMui.contract.show" class="mui-form-item-error">{{loginRulesMui.contract.text}}</div>
          </div>
          <div class="mui-form-item">
            <div class="mui-form-item-label">
              手机号
            </div>
            <div class="mui-form-item-value">
              <input @blur="blur('phone')" v-model.trim="loginForm.phone" v-removeSpace:numberLine="loginForm.phone" maxlength="11" type="text" placeholder="请输入11位手机号码">
            </div>
            <div v-if="loginRulesMui.phone.show" class="mui-form-item-error">{{loginRulesMui.phone.text}}</div>
          </div>
          <div class="mui-form-item">
            <div class="mui-form-item-label">
              验证码
            </div>
            <div class="mui-form-item-value">
              <input @blur="blur('code')" v-model.trim="loginForm.code" v-removeSpace:numberLine="loginForm.code" type="text" maxlength="6" placeholder="请输入验证码">
              <el-button :loading="loadingCode" :disabled="getCodeTime>0?true:false" @click.stop="getCode()" class="mui-get-code" type="text">{{getCodeTime?`${getCodeTime}s后重新获取`:'获取验证码'}}</el-button>
            </div>
            <div v-if="loginRulesMui.code.show" class="mui-form-item-error">{{loginRulesMui.code.text}}</div>
          </div>
          <div class="mui-form-item">
            <div class="mui-form-item-label">
              店铺类型
            </div>
            <div class="mui-form-item-value">
              <input @blur="blur('shopType')" v-model.trim="loginForm.shopType" type="text" maxlength="100" placeholder="商超/零售/餐饮">
            </div>
            <div v-if="loginRulesMui.shopType.show" class="mui-form-item-error">{{loginRulesMui.shopType.text}}</div>
          </div>
          <div class="mui-form-item">
            <div class="mui-form-item-label">
              店铺数量
            </div>
            <div class="mui-form-item-value">
              <input @blur="blur('shopFace')" v-model.trim="loginForm.shopFace" type="text" maxlength="100" placeholder="例如20家">
            </div>
            <div v-if="loginRulesMui.shopFace.show" class="mui-form-item-error">{{loginRulesMui.shopFace.text}}</div>
          </div>
        </div>
        <div class="mui-login-btn">
          <div v-if="type==2" class="mui-title-des">提交申请后，我们将于1个工作日内与您联系</div>
          <el-button :loading="loading" @click="handleLogin()" type="primary" style="width:100%; height:40px;">{{type==1?'免费':'申请'}}试用</el-button>
          <el-checkbox class="mui-login-agree" v-model="checked">我已阅读并同意<el-link target="_blank" href="https://privacy.kemai.com.cn/petroleum/privacy.html" :underline="false" type="primary">《个人信息授权与隐私政策》</el-link>
          </el-checkbox>
        </div>
      </template>
      <template v-else>
        <el-image style="margin: 10% 10%; width:80%;height:auto" :src="showImgUrl" fit="fill"></el-image>
      </template>
    </div>
  </div>
</template>

  <script>
import MD5Util from '@/utils/MD5Util'
import { remainAddTrack, remainSendMsg, remainVaildCode, background } from '@/api/login'
export default {
  name: 'leaveInformation',
  data () {
    return {
      openInfo: {
        'YCMO1': {
          way: 'http',
          url: 'https://321559.ycm.kemai.com.cn/KmcyWeb/home/HCMLogin.aspx?004C002C0039003000300031002C0039003000300031'
        },
        'YKL': {
          way: 'http',
          url: 'https://wxwork.kemai.com.cn/login?isExperience=true'
        },
        'YKLHY': {
          way: 'http',
          url: 'https://wxwork.kemai.com.cn/memberGuide'
        },
        'BLDPRO': {
          way: 'http',
          url: 'http://waxiao-cs.kemai.cn:81/webshopdemo_bld/index.html#/home'
        },
        'Web1': {
          way: 'http',
          url: 'http://waxiao-cs.kemai.cn:81/WebShopDemo_bz/index.html#/home'
        },
        'HMY01': {
          way: 'http',
          url: 'https://hmt.haomaiyun.com/#/login?tenant_id=10266&account_mobile=13666886688'
        },
        'WXCPF': {
          way: 'http',
          url: 'http://waxiao-cs.kemai.cn:81/WebShopDemo_xwzx/Home/CityPlatFormLogin.aspx'
        },
        'HCMZB': {
          way: 'http',
          url: 'http://kmcyhcm-ys.kemai.cn:8090/KmcyWeb/Home/HCMLogin.aspx?Demo'
        },
        'YSCOMM': {
          way: 'http',
          url: 'https://youshu.cs.kemai.com.cn/xddpc/login?key=ad48b0b64aecbaefff0f50ff23efb9b0'
        },
        'CRM': {
          way: 'img',
          url: require('./../../static/img/leven/CRM.jpg')
        },
        'LBT': {
          way: 'img',
          url: require('./../../static/img/leven/LBT.jpg')
        },
        'XQZF': {
          way: 'img',
          url: require('./../../static/img/leven/XQZF.png')
        },
        'HCC': {
          way: 'img',
          url: require('./../../static/img/leven/HCC.png')
        },
        'QYQB': {
          way: 'img',
          url: require('./../../static/img/leven/QYQB.jpg')
        },
        'DWT': {
          way: 'img',
          url: require('./../../static/img/leven/DWT.jpg')
        }
      },
      showImg: false,
      showImgUrl: '',
      checked: false,
      bigBg: require('./../../static/img/leaveInformation.png'),
      bigBgMui: require('./../../static/img/leaveInformationmui.png'),
      loginForm: { contract: '', phone: '', code: '', shopType: '', shopFace: '' },
      loginRulesMui: {
        contract: {
          show: false,
          text: '请输入姓名'
        },
        phone: {
          show: false,
          text: '请输入手机号'
        },
        code: {
          show: false,
          text: '请输入验证码'
        },
        shopType: {
          show: false,
          text: '请输入店铺类型'
        },
        shopFace: {
          show: false,
          text: '请输入店铺数量'
        }
      },
      loginRules: {
        contract: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
        code: [{ required: true, trigger: 'blur', message: '请输入验证码' }],
        shopType: [{ required: true, trigger: 'blur', message: '请输入店铺类型' }],
        shopFace: [{ required: true, trigger: 'blur', message: '请输入店铺数量' }],
        phone: [
          {
            required: true,
            trigger: ['blur'],
            validator: async (rule, value, callback) => {
              let reg = /^[0-9]*$/
              if (!value) return callback(new Error('请输入手机号'))
              else if (value.length !== 11 || !reg.test(value)) return callback(new Error('请输入正确的手机号'))
              else callback()
            }
          }
        ]
      },
      loading: false,
      loadingCode: false,
      getCodeTime: 0
    }
  },
  computed: {
    type () {
      return this.$route.query.type
    },
    isPC () {
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      let flagPc = true
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flagPc = false
          break
        }
      }
      return flagPc
    }
  },
  created () {
    this.background()
    console.log('666666')
  },
  methods: {
    blur (who) {
      const value = this.loginForm[who]
      if (value === '') {
        this.loginRulesMui[who].show = true
        return true
      } else {
        if (who === 'phone') {
          let reg = /^[0-9]*$/
          if (value.length !== 11 || !reg.test(value)) {
            this.loginRulesMui[who].show = true
            this.loginRulesMui[who].text = '请输入正确的手机号'
            return true
          }
        }
        this.loginRulesMui[who].show = false
        return false
      }
    },
    IEVersion () {
      let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        let fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6;//IE版本<=7
        }
      } else if (isEdge) {
        return 'edge';//edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1;//不是ie浏览器
      }
    },
    async background () {
      if (!this.isPC) {
        this.bigBg = this.bigBgMui
      }
      if (localStorage.getItem('leaveInformationBacImage')) {
        this.bigBg = localStorage.getItem('leaveInformationBacImage')
      }
      if (this.IEVersion() == -1) {
        const res = await background(this.signMD5Util({ systemId: this.isPC ? 3 : 4 }))
        if (res) {
          this.bigBg = res
          localStorage.setItem('leaveInformationBacImage', this.bigBg)
        }
      }
    },
    codeTimeMinus () {
      this.getCodeTime--
      if (this.getCodeTime === 0) {
        return
      }
      setTimeout(() => {
        this.codeTimeMinus()
      }, 1000)
    },
    async getCode () {
      if (this.getCodeTime || this.loadingCode) {
        return
      }
      if (!this.loginForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      let reg = /^[0-9]*$/
      if (this.loginForm.phone.length !== 11 || !reg.test(this.loginForm.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      try {
        this.loadingCode = true
        await remainSendMsg(this.signMD5Util({ phone: this.loginForm.phone }))
        this.$message.success('验证码发送成功')
        this.getCodeTime = 60
        this.codeTimeMinus()
      } catch (error) {
      } finally {
        this.loadingCode = false
      }
    },
    signMD5Util (reqData) {
      const keyS = Object.keys(reqData)
      let str = ''
      for (let i = 0; i < keyS.length; i++) {
        let key = keyS[i]
        let value = reqData[keyS[i]]
        str += `${key.toLowerCase()}=${isNaN(value) ? value.toLowerCase() : value}`
      }
      let value = {
        sign: MD5Util.md5(`${str}F2A494A96F550AFE8A77B031A8DFDCBE72A012B086BFEB77`),
        reqData,
        timestamp: new Date().getTime()
      }
      return value
    },
    async subData () {
      try {
        this.loading = true
        await remainVaildCode(this.signMD5Util({
          code: this.loginForm.code,
          phone: this.loginForm.phone
        }))
        try {
          let subData = {
            contract: this.loginForm.contract,
            phone: this.loginForm.phone,
            productId: this.$route.query.id || '',
            shopFace: this.loginForm.shopFace,
            shopType: this.loginForm.shopType
          }
          if (this.$route.query.source) {
            subData.source = this.$route.query.source
          }
          await remainAddTrack(this.signMD5Util(subData))
          this.$message.success('提交成功')
          this.subSucess()
        } finally {
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
    subSucess () {
      if (this.type === '1' && this.$route.query.id) {
        const { url = '', way = '' } = this.openInfo[this.$route.query.id] || {}
        if (way === 'http') {
          setTimeout(() => {
            window.open(url)
          }, 1000)
        }
        if (way === 'img') {
          this.showImg = true
          this.showImgUrl = url
        }
      }
    },
    handleLogin () {
      // 为了方便测试成功的跳转
      if (this.$route.query.test) {
        this.subSucess()
      }
      if (this.isPC) {
        this.$refs.loginForm.validate(async (valid) => {
          if (valid) {
            if (!this.checked) {
              this.$message.warning('请勾选协议')
              return ''
            }
            this.subData()
          }
        })
      } else {
        if (this.blur('contract') || this.blur('phone') || this.blur('code') || this.blur('shopType') || this.blur('shopFace')) {
          return ''
        }
        if (!this.checked) {
          this.$message.warning('请勾选协议')
          return ''
        }
        this.subData()
      }
    }
  }
}
  </script>
<style rel="stylesheet/scss">
html {
  font-size: 20px;
}
@media only screen and (min-width: 401px) {
  html {
    font-size: 25px !important;
  }
}
@media only screen and (min-width: 428px) {
  html {
    font-size: 26.75px !important;
  }
}
@media only screen and (min-width: 481px) {
  html {
    font-size: 30px !important;
  }
}
@media only screen and (min-width: 569px) {
  html {
    font-size: 35px !important;
  }
}
@media only screen and (min-width: 641px) {
  html {
    font-size: 40px !important;
  }
}
.centers-title {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
}
.centers-title-des {
  margin: 12px 0px;
  color: #8f9295;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  text-align: center;
}
.form-box {
  margin-top: 16px;
}
.centers {
  width: auto;
  float: right;
  margin: 0px;
  position: fixed;
  right: 0px;
  top: 0px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-input {
  display: inline-block;
  height: 40px;
  width: 85%;
}
.el-input input {
  background: initial;
  border: 0;
  -webkit-appearance: none;
  border-radius: 0px;
  padding: 12px 5px 12px 0px;
  line-height: 1px;
  font-family: Arial, Helvetica, sans-serif;
  margin-bottom: 4px;
}
.el-form-item {
  border-bottom: 1px solid #cccccc;
  background: #fff;
  border-radius: 0px;
  color: #454545;
}
.el-form-item__label {
  text-align: left !important;
  padding-left: 0px;
  color: #333333;
  font-size: 14px;
}
.get-code {
  position: absolute !important;
  right: 0px;
  right: 0px;
}
.login-form {
  width: 444px;
  height: auto;
  max-width: 100%;
  padding: 50px;
  border-radius: 8px;
  float: right;
  margin: 0px 100px 0px 0px;
  background-color: #fff;
}
.login-btn {
  margin: 50px 0 5px;
}
.mui-box {
  position: fixed;
  left: 0rem;
  top: 0rem;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  background-size: 100% auto;
}
.mui-con {
  width: 100%;
  height: auto;
  min-height: calc(100% - 6.8rem);
  background: #fff;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  position: fixed;
  left: 0rem;
  bottom: 0.56rem;
}
.mui-con-title {
  padding: 0.6rem;
  width: 100%;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
  background: linear-gradient(180deg, #d0e1ff 0%, rgba(255, 255, 255, 0) 100%);
  color: #31353c;
  font-size: 0.9rem;
  font-weight: 600;
}
.mui-title-des {
  padding: 0rem 0.6rem;
  color: #91949f;
  font-size: 0.6rem;
  width: 100%;
  text-align: center;
  margin-bottom: 0.6rem;
}
.mui-form {
  padding: 0.6rem;
  width: 100%;
  height: auto;
}
.mui-form-item {
  position: relative;
  width: 100%;
  height: auto;
}
.mui-form-item-label {
  position: absolute;
  left: 0rem;
  top: 0rem;
  font-size: 0.8rem;
  text-align: left;
  color: #31353c;
  height: 100%;
  font-weight: 400;
  line-height: 2.8rem;
}
.mui-form-item-value {
  width: 100%;
  height: 2.8rem;
  border-bottom: 0.04rem solid #e9edf5;
}
.mui-form-item-value > input {
  width: 100%;
  height: 100%;
  font-size: 0.8rem;
  padding-left: 4.2rem;
  color: #31353c;
}
.mui-get-code {
  position: absolute;
  right: 0rem;
  top: -0.28rem;
  width: auto;
  height: 100%;
  line-height: 2.8rem;
  color: #1c87ff;
  font-size: 0.6rem;
  font-weight: 400;
}
.mui-form-item-error {
  color: #fc554a;
  font-weight: 400;
  font-size: 0.6rem;
  width: 100%;
  position: absolute;
  padding-left: 4.2rem;
  left: 0rem;
  bottom: -0.88rem;
}
.mui-login-btn {
  margin: 1.25rem 0rem;
  padding: 0rem 0.6rem;
}
.mui-login-btn button {
  font-size: 0.9rem;
  color: #fff;
  width: 100%;
  height: 2rem !important;
  border-radius: 0.25rem;
}
.mui-login-agree {
  width: 100%;
  text-align: center;
  margin-top: 0.8rem;
}
.mui-login-agree a {
  font-size: 0.7rem !important;
}
/deep/.mui-login-agree > span:last-child {
  font-size: 0.6rem !important;
  font-weight: 400 !important;
}
/deep/.mui-login-agree > span:first-of-type span {
  width: 0.7rem !important;
  height: 0.7rem !important;
}
/deep/.mui-login-agree > span:first-of-type span::after {
  font-size: 0.7rem !important;
  left: 0.2rem !important;
  top: 0.1rem !important;
}
.login-container {
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  min-height: 500px;
  width: 100%;
  background-color: #2d3a4b;
  position: fixed;
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/bossIndex.vue